
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 9.196v7.425C21 18.487 19.458 20 17.557 20H4.443C2.542 20 1 18.487 1 16.621V5.38C1 3.513 2.542 2 4.443 2h4.612C10.13 2 11 2.854 11 3.908c.017 1.042.883 1.878 1.945 1.878h4.612c.919 0 1.8.36 2.446 1A3.346 3.346 0 0121 9.196z","fill":"#7B01B5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.177 9.717l-3.469 3.47a.969.969 0 00.144 1.346l2.615 2.615a.969.969 0 001.346.144l3.47-3.47a.768.768 0 00.213-.61l-.18-2.464a1.19 1.19 0 00-1.064-1.064l-2.463-.18a.768.768 0 00-.612.213zm1.991 2.701a.566.566 0 01-.41-.176.566.566 0 010-.82.58.58 0 01.82.82.567.567 0 01-.41.176z","fill":"#fff"}})])
          )
        }
      }
    